"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_core_1 = require("owa-options-core");
var store_1 = require("../store/store");
var owa_calendar_configuration_1 = require("owa-calendar-configuration");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    calendarConfiguration: function () { return owa_calendar_configuration_1.getCalendarConfiguration(); },
})(function isWeatherOptionDirty(state) {
    if (!state.calendarConfiguration) {
        return false;
    }
    var weatherEnabled = owa_options_core_1.getFallbackValueIfNull(state.optionState.weatherEnabled, state.calendarConfiguration.WeatherEnabled);
    var weatherUnit = owa_options_core_1.getFallbackValueIfNull(state.optionState.weatherUnit, state.calendarConfiguration.WeatherUnit);
    return (weatherEnabled !== state.calendarConfiguration.WeatherEnabled ||
        weatherUnit !== state.calendarConfiguration.WeatherUnit);
});
//# sourceMappingURL=isWeatherOptionDirty.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/calendar/owa-weather-option/lib/utils/isWeatherOptionDirty.js
// module id = 5258
// module chunks = 2